import '../styles/main.scss';
import { initInputs } from '@components/inputs';
import { initAccordions } from '@components/accordions';
import { initModals } from '@components/modals';
import { initVideoControls } from '@components/media';
import { initKiwiSizingA11y } from '@components/kiwi-sizing-a11y';

(() => {
  initInputs();
  initAccordions();
  initModals();
  initVideoControls();
  initKiwiSizingA11y();
})();
